import {Component, Input, OnInit} from "@angular/core";
import {EcommerceService} from "../ecommerce.service";
import {DbModalService} from "../../../../modules/modal/modal";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {TextUtils} from "../../../../shared/utils/text-utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";

@Component({
    selector: 'db-ecommerce-payments-intro',
    templateUrl: './payments-intro.component.html',
    styleUrls: ['./payments-intro.component.scss'],
    standalone: false
})
export class EcommercePaymentsIntroComponent implements OnInit {

  @Input() websiteId: number;
  public loading: boolean;
  public paymentInfoList = [
    {
      title: TextUtils.getText('text_paymentManagement'),
      desc: TextUtils.getText('text_managePaymentSettings')
    },
    {
      title: TextUtils.getText('text_salesAndRevenueMonitoring'),
      desc: TextUtils.getText('text_gainInstantFinancialInsightsWithRealTimeMonitoring')
    },
    {
      title: TextUtils.getText('text_testPayments'),
      desc: TextUtils.getText('text_testPaymentIntegrationBeforeProcessingRealTransactions')
    },
    {
      title: TextUtils.getText('text_enhancedSecurity'),
      desc: TextUtils.getText('text_payOffersAdvancedSecurityAgainstFraud')
    }
  ];

  constructor(
    private _modalService: DbModalService,
    private _ecommerceService: EcommerceService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
  }

/*  public setupIntro(): void {
    this.loading = true;
    this._ecommerceService.payEngineSetup(this.websiteId)
      .pipe(
        filter(response => !!response),
        first()
      ).subscribe((response) => {
      if (response && response.success) {
      }
      this.loading = false;
    });
  }*/



  public openOneWeekFreeDialog(): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: 'Locked button click',
      eventLabel: '10Web Payments: Set Up',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
    const options = {
      overflowHidden: false,
    };
    if (!firstTime) {
      options['width'] = 1240;
    } else {
      options['width'] = 460;
      options['height'] = 600;
    }
    const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
    modal.componentInstance.showFirstTime = firstTime;
  }

}
